import { useEffect, useState } from 'react';
import apiService from '../../services/api';
import {
  MERCHANT_DOCUMENTS_UPDATED,
  countDocumentActionsRequired,
} from './merchantDocumentsModel';

export function useMerchantDocumentsActionRequired(enabled) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }

    let cancelled = false;
    const apply = (documents) => {
      if (!cancelled) setCount(countDocumentActionsRequired(documents));
    };

    const onUpdate = (event) => apply(event.detail?.documents);

    window.addEventListener(MERCHANT_DOCUMENTS_UPDATED, onUpdate);
    apiService.listMerchantDocuments()
      .then((data) => apply(data?.documents))
      .catch(() => apply([]));

    return () => {
      cancelled = true;
      window.removeEventListener(MERCHANT_DOCUMENTS_UPDATED, onUpdate);
    };
  }, [enabled]);

  return count;
}
